import createReducer from './baseReducer';

export default createReducer('accessories', 'accessory');
